
          export const options = {
  "includeNodeModules": false,
  "options": {},
  "clients": {
    "default": {
      "endpoint": "https://benchmark-uat.stellate.sh",
      "options": {
        "requireCredentials": false
      }
    },
    "authenticatedClient": {
      "endpoint": "https://test.benchmarkminerals.com/wp/graphql",
      "options": {
        "requireCredentials": true
      }
    }
  }
}
        